import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { T as TRPCClientError } from './TRPCClientError-f020d3c5.esm.js';

function transformRPCResponse(_ref) {
  var envelope = _ref.envelope,
      runtime = _ref.runtime;

  if ('error' in envelope) {
    return TRPCClientError.from(_objectSpread(_objectSpread({}, envelope), {}, {
      error: runtime.transformer.deserialize(envelope.error)
    }));
  }

  if (envelope.result.type === 'data') {
    return _objectSpread(_objectSpread({}, envelope.result), {}, {
      data: runtime.transformer.deserialize(envelope.result.data)
    });
  }

  return envelope.result;
}

function httpRequest(props) {
  var type = props.type,
      rt = props.runtime,
      input = props.input,
      path = props.path;
  var ac = rt.AbortController ? new rt.AbortController() : null;
  var method = {
    query: 'GET',
    mutation: 'POST',
    subscription: 'PATCH'
  };

  function getUrl() {
    var url = props.url + '/' + path;
    var queryParts = [];

    if (props.searchParams) {
      queryParts.push(props.searchParams);
    }

    if (type === 'query' && input != null) {
      queryParts.push("input=".concat(encodeURIComponent(JSON.stringify(rt.transformer.serialize(input)))));
    }

    if (queryParts.length) {
      url += '?' + queryParts.join('&');
    }

    return url;
  }

  function getBody() {
    if (type === 'query') {
      return undefined;
    }

    return JSON.stringify({
      input: rt.transformer.serialize(input)
    });
  }

  var promise = new Promise(function (resolve, reject) {
    var url = getUrl();
    rt.fetch(url, {
      method: method[type],
      signal: ac === null || ac === void 0 ? void 0 : ac.signal,
      body: getBody(),
      headers: _objectSpread({
        'content-type': 'application/json'
      }, rt.headers())
    }).then(function (res) {
      return res.json();
    }).then(function (json) {
      resolve(json);
    }).catch(reject);
  });

  var cancel = function cancel() {
    ac === null || ac === void 0 ? void 0 : ac.abort();
  };

  return {
    promise: promise,
    cancel: cancel
  };
}

export { httpRequest as h, transformRPCResponse as t };
